[<RequireQualifiedAccess>]
module Client.Components.Disclaimer

open Fable.React
open Fable.React.Props
open Fulma

let disclaimer (isApproved: bool) (onChange: bool -> unit) =
    Field.div [] [
        Control.div [] [
            Label.label [] [ str "AGB und Haftungsausschluss" ]
            Checkbox.checkbox [] [
                Checkbox.input [
                    Props [
                        HTMLAttr.Checked isApproved
                        OnChange(fun _ -> not isApproved |> onChange)
                    ]
                ]

                str " Ich erkläre mich mit der "
                a [
                    Href "https://mysens.eu/nutzungsbedingungen-mysens-network/"
                    Target "_blank"
                ] [ str "AGB" ]
                str " und "
                a [
                    Href "https://mysens.eu/nutzungsbedingungen-mysens-network/"
                    Target "_blank"
                ] [ str "Haftungsausschluss" ]
                str " von mysens.eu und mysens.network einverstanden"
            ]
        ]
    ]